export const drawBox = (ctx, pos, {fill = '#fff', opacity = 1.0, chip} = {}) => {
  // draw a rect at given position
  const {top,left,right,bottom} = pos
  const {width, height} = getDims(ctx)

  ctx.save()
  if(opacity) ctx.globalAlpha= opacity
  ctx.fillStyle = fill
  const l = left *width
  const t = top *height
  const w =  width * (right-left)
  const h = height * (bottom - top)
  //console.log('drawbox l,t,w,h',l,t,w,h)
  ctx.fillRect(l,t,w,h)
  ctx.restore()
  if(chip) drawChip(ctx, {
    left: l,
    top: t
  }, chip)
}
export const drawChip = (ctx, {left, top}, {
  color,
  text
} ={}) => {

  ctx.save()
  ctx.font = "12px Roboto"
  ctx.fillStyle = color
  ctx.fillText(text, left + 2, top + 8 );
  ctx.restore()

}
export const clearCanvas = (ctx) => {
  ctx.clearRect(0,0,getWidth(ctx),getHeight(ctx))
}
export const getWidth = (ctx) => ctx.canvas.width
export const getHeight = (ctx) => ctx.canvas.height
const getDims = (ctx) => ({
  width: getWidth(ctx),
  height: getHeight(ctx)
})
// this takes the offsetx and offsety and returns the normalized position on the canvas
export const getNormalizedBox = ({ ctx, evt }) => {
  const { width, height } = getDims(ctx)
  const top = evt.offsetY / height
  const left = evt.offsetX / width
  return {
    top,
    left,
    bottom: top,
    right: left
  }
}

// possible that the canvas height and width might need reset if there's been resize of screen
export const makeCanvas = ({ ref, container, forceHeight, forceWidth }) => {
  let { clientHeight, clientWidth } = container || {}
  clientHeight = forceHeight || clientHeight
  clientWidth = forceWidth || clientWidth
  if (
    ref &&
    container &&
    (ref.height !== clientHeight || ref.width !== clientWidth)
  ) {
    ref.height = clientHeight
    ref.width = clientWidth
  } else {
    // it wasnt ready or isnt needed - it'll happen later
  }
  return ref
}